import { Maybe } from "purify-ts";
import { DateLike, toValidLuxonDateTime } from "./to-luxon-datetime";

export type DateDisplayFormatTypes =
  | luxon.DateTimeFormatOptions
  | string
  | ((dt: luxon.DateTime) => string);

export const toValidLuxonDateTimeFormat = (
  providedDate: DateLike,
  format: DateDisplayFormatTypes
): Maybe<string> => {
  return toValidLuxonDateTime(providedDate).map((date) => {
    try {
      if (typeof format === "string") {
        return date.toFormat(format);
      }
      if (typeof format === "function") {
        return format(date);
      }
      if (typeof format === "object") {
        return date.toLocaleString(format);
      }
      return null;
    } catch (e) {
      return null;
    }
  });
};
